function Footer() {
    return (
        <div className="footer-section">
            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/malcolm-hess3/"><img  alt="linkedin" src="https://img.icons8.com/ios-filled/50/000000/linkedin.png"/></a>
            <a target="_blank" rel="noreferrer" href="https://github.com/malcolmhess3"><img  alt="linkedin" src="https://img.icons8.com/ios-filled/50/000000/github.png"/></a>
        </div>
    )
}

export default Footer
